import { LoanExampleText } from '@/components/LoanExampleText/index.ts';
import { UnderlinedText } from '@/components/UnderlinedText/index.ts';
import useBrainSession from '@/services/BrainSession/useBrainSession.ts';
import { Button } from '@/ui/button-2.tsx';

import { Section } from '../marketing/section/section.tsx';

type RefinancingHeroProps = {
  /** Step the debt check chat opens at — differs between `/refinansiering` and the article pages. */
  chatStep: string;
};

/** Hero used on `/refinansiering` and the economy article pages. */
export const RefinancingHero = ({ chatStep }: RefinancingHeroProps) => {
  const { toggleChat } = useBrainSession();

  return (
    <Section.Container className="bg-white text-v1-background-200">
      <Section.Content className="flex flex-col items-center py-8 pb-20">
        <h1 className="mb-10 max-w-4xl text-center typography-v1-display text-balance xl:mt-12 [&_path]:stroke-3">
          Søk refinansiering hos <UnderlinedText distance="0.22em">flere banker</UnderlinedText>!
        </h1>
        <h2 className="mb-12 max-w-md text-center typography-v1-body2 text-pretty text-v1-neutral-100">
          Se om du kan få <b>lavere rente</b> på dine forbrukslån og kredittkort
        </h2>

        <Button
          type="button"
          color="blue"
          onClick={() =>
            toggleChat({
              goal: 'debt_check',
              step: chatStep,
            })
          }
        >
          Søk nå
        </Button>

        <p className="mt-4 mb-20 flex text-xs leading-normal text-v1-neutral-60 italic sm:text-sm">
          Trygt og raskt med BankID
        </p>

        <LoanExampleText className="max-w-2xl text-center typography-v1-body4 text-v1-neutral-60" />
      </Section.Content>
    </Section.Container>
  );
};
